import {
  INSURANCE_DETAIL_UPDATE_LIST_CLEAR_FILTERS,
  INSURANCE_DETAIL_UPDATE_LIST_ERROR,
  INSURANCE_DETAIL_UPDATE_LIST_RECEIVED,
  INSURANCE_DETAIL_UPDATE_LIST_REQUEST,
  INSURANCE_DETAIL_UPDATE_LIST_SET_FILTERS,
  INSURANCE_DETAIL_UPDATE_LIST_SET_PAGE,
  INSURANCE_DETAIL_UPDATE_LIST_UNLOAD,
  INSURANCE_DETAIL_UPDATE_LIST_UNLOAD_PERSIST_FILTERS,
  INSURANCE_DETAILS_REQUEST,
  INSURANCE_DETAILS_UPDATED,
} from '../constants';
import { hydraPageCount } from '../../helper/apiUtils';
import { setFiltersInSession } from '../../routing/filters';

const reducer = (
  state = {
    insuranceDetails: null,
    insuranceDetailUpdates: [],
    isFetchingInsuranceDetails: false,
    currentPage: 1,
    pageCount: null,
    filters: {},
  },
  action,
) => {
  switch (action.type) {
    case INSURANCE_DETAILS_REQUEST:
      return {
        ...state,
      };
    case INSURANCE_DETAILS_UPDATED:
      return {
        ...state,
      };
    case INSURANCE_DETAIL_UPDATE_LIST_UNLOAD:
      return {
        insuranceDetailUpdates: [],
        isFetchingInsuranceDetails: false,
        currentPage: 1,
        pageCount: null,
      };

    case INSURANCE_DETAIL_UPDATE_LIST_UNLOAD_PERSIST_FILTERS:
      return {
        ...state,
        insuranceDetailUpdates: [],
        isFetchingInsuranceDetails: false,
        currentPage: 1,
        pageCount: null,
      };

    case INSURANCE_DETAIL_UPDATE_LIST_REQUEST:
      return {
        ...state,
        isFetchingInsuranceDetails: true,
      };

    case INSURANCE_DETAIL_UPDATE_LIST_RECEIVED:
      return {
        ...state,
        insuranceDetailUpdates: action.data['hydra:member'],
        pageCount: hydraPageCount(action.data),
        isFetchingInsuranceDetails: false,
      };

    case INSURANCE_DETAIL_UPDATE_LIST_ERROR:
      return {
        ...state,
        isFetchingInsuranceDetails: false,
      };
    case INSURANCE_DETAIL_UPDATE_LIST_SET_PAGE:
      return {
        ...state,
        currentPage: action.page,
      };
    case INSURANCE_DETAIL_UPDATE_LIST_SET_FILTERS:
      setFiltersInSession(action.routeKey || 'insuranceDetailUpdates', action.filters);
      return {
        ...state,
        filters: action.filters,
        currentPage: 1,
      };

    case INSURANCE_DETAIL_UPDATE_LIST_CLEAR_FILTERS:
      setFiltersInSession(action.routeKey || 'insuranceDetailUpdates', {});
      return {
        ...state,
        filters: {},
      };

    default:
      return state;
  }
};

export default reducer;
